function ReasonForTaxExempt() {
    return (
      <>
        <div className="font-bold text-lg mb-16">ReasonForTaxExempt</div>
      </>
    );
  }
  
  export default ReasonForTaxExempt;